var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgShareIcon = function SvgShareIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ShareIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.286 6.32h.87c.961 0 1.74.78 1.74 1.74v8.7c0 .96-.779 1.74-1.74 1.74H2.716a1.74 1.74 0 0 1-1.739-1.74v-8.7c0-.96.779-1.74 1.74-1.74h.87a.87.87 0 1 1 0 1.74h-.87v8.7h10.44v-8.7h-.87a.87.87 0 1 1 0-1.74ZM7.276.536a.868.868 0 0 1 1.321 0l2.415 2.415a.87.87 0 1 1-1.23 1.23l-.975-.975v8.335a.87.87 0 0 1-1.74 0V3.205l-.976.975a.87.87 0 1 1-1.23-1.23L7.276.535Z",
    fill: "#5C7AFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ShareIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.977 .231)",
    d: "M0 0h13.919v18.269H0z"
  })))));
};

export default SvgShareIcon;